import type { ContentNugget } from '@backrs_ui/common-ui';

import { toAgentContextNugget } from '@backrs_ui/grow-ui/src/agentContext/toAgentContextNugget';
import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = ({
  searchTerm,
  selectedThemes,
  filteredNuggets,
  totalNuggetCount,
}: {
  searchTerm: string;
  selectedThemes: string[];
  filteredNuggets: readonly ContentNugget[];
  totalNuggetCount: number;
}) => {
  useRegisterAgentContext({
    kind: 'nuggetList',
    description: 'Filterable list of learning nuggets for this competency',
    nuggets: filteredNuggets.map(toAgentContextNugget),
    data: {
      searchTerm: searchTerm || null,
      selectedThemes: selectedThemes.length > 0 ? selectedThemes : null,
      totalNuggetCount,
    },
  });
};
